import DataExportStatusConstants from '~/constants/data-export-status-constants';

const defaultValues: ExportHistoryEntry = {
  id: '',
  date: '',
  metaData: {},
  status: DataExportStatusConstants.UNDEFINED,
  isLoadingDownloadUrl: false,
};

export interface ExportHistoryEntry {
  id: string;
  date: string;
  metaData: Record<string, string>;
  status: DataExportStatusConstants;
  isLoadingDownloadUrl: boolean;
}

export const isSlow = (entry: ExportHistoryEntry | null) =>
  entry?.status === DataExportStatusConstants.IN_PROGRESS_SLOW;

export const createExportHistoryEntry = (
  values?: Partial<ExportHistoryEntry>
) => {
  return {
    ...defaultValues,
    ...values,
  };
};
